import React from 'react'
import { FooterProps } from '../footerWrapper'
import * as Accordion from '@radix-ui/react-accordion'
import {
  AccordionContent,
  MobileAccordionTrigger,
} from '../Accordions/Accordions'
import getSections from '../../helpers/getSections'
import * as styles from './MobileFooterWrapper.css'
import BuyFromApp from '../BuyFromApp/BuyFromApp'

function MobileFooterWrapper({
  lang = 'pt',
  isCollapsible = true,
}: FooterProps) {
  return (
    <div className={styles.Container}>
      <BuyFromApp lang={lang} />
      <Accordion.Root collapsible={isCollapsible} type="single">
        {getSections(lang).map((section) => (
          <Accordion.Item
            value={section.title}
            key={section.key}
            className={styles.AccordionItem}
          >
            <MobileAccordionTrigger>{section.title}</MobileAccordionTrigger>
            <AccordionContent>
              <ul className={styles.AccordionContentUl}>
                {section.options.map((option, idx) => (
                  <li
                    key={`section-option-${idx}`}
                    className={styles.AccordionContentLi}
                  >
                    <a
                      className={styles.AccordionLink}
                      target="_blank"
                      href={option.link}
                      rel="noopener noreferrer"
                    >
                      {option.name}
                    </a>
                  </li>
                ))}
              </ul>
            </AccordionContent>
          </Accordion.Item>
        ))}
      </Accordion.Root>
    </div>
  )
}

export default MobileFooterWrapper
